import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";

export default function LoadingScreen() {
  const [visible, setVisible] = useState(true);
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start;
    const duration = 1600;
    let raf;
    const step = (t) => {
      if (!start) start = t;
      const p = Math.min(1, (t - start) / duration);
      setCount(Math.round(p * 100));
      if (p < 1) raf = requestAnimationFrame(step);
      else setTimeout(() => setVisible(false), 280);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="loading-screen"
          className="fixed inset-0 z-[10000] flex items-center justify-center"
          style={{ background: "#111111", color: "#FAF8F5" }}
          initial={{ y: 0 }}
          exit={{ y: "-100%" }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
        >
          <div className="w-full max-w-[92%] flex flex-col items-start justify-between h-full py-10">
            <div className="flex items-center gap-3 opacity-80">
              <svg width="22" height="18" viewBox="0 0 22 18" fill="none" aria-hidden="true">
                <path d="M1 17 L4 3 L8 8 L11 3 L14 8 L18 3 L21 17 Z" stroke="#FAF8F5" strokeWidth="1" fill="none" />
              </svg>
              <span className="font-sans text-[11px] tracking-[0.24em] uppercase">La Michi Agencia</span>
            </div>

            <div className="flex items-end justify-between w-full">
              <div className="flex items-end gap-6">
                <svg width="70" height="30" viewBox="0 0 70 30" aria-hidden="true">
                  <g className="cat-eye" fill="#FF6B2C">
                    <ellipse cx="18" cy="15" rx="6" ry="9" />
                    <ellipse cx="52" cy="15" rx="6" ry="9" />
                  </g>
                  <g fill="#111111">
                    <ellipse cx="18" cy="15" rx="1.6" ry="6" />
                    <ellipse cx="52" cy="15" rx="1.6" ry="6" />
                  </g>
                </svg>
                <span className="font-display text-[11vw] leading-[0.85] tightest">
                  {String(count).padStart(3, "0")}
                </span>
              </div>
              <div className="hidden md:block font-sans text-[11px] tracking-[0.24em] uppercase opacity-60">
                Índice · 001
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
